import { context } from './backend';

export function getPlatform() {
  const userAgent = navigator.userAgent || navigator.vendor;
  let platform;

  if (/android/i.test(userAgent)) {
    platform = 'android';
  } else if (
    (/iPad|iPhone|iPod/.test(navigator.platform) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) &&
    !window.MSStream
  ) {
    platform = 'ios';
  } else {
    platform = 'web';
  }
  return platform;
}

export function formatFormStates({ data }) {
  return data.map((el) => {
    return {
      id: el.id,
      name: el.Description,
    };
  });
}

export function formatValueList(data) {
  return data.map((el) => {
    return {
      ...el,
      value: el.id,
      label: el.description,
      checked: false,
      ...el.extraFields,
    };
  });
}

export function parseFeild(field) {
  if (!field) return null;
  if (typeof field !== 'string') return field;
  try {
    return JSON.parse(field);
  } catch (error) {
    console.warn(error);
    return null;
  }
}

export function formatFormInitData(data) {
  const jsonData = data.jsonData ? parseFeild(data.jsonData) : {};

  return {
    account: context.entity,
    user: {
      username: context.userData.user,
      id: context.userData.nidUsuario,
      name: context.userData.nombre,
      lang: context.userData.langISOInterface,
      langDB: context.userData.langISODDBB,
      locale: context.userData.locale,
    },
    endState: context.endState,
    idState: context.idState,
    isReadonly: context.isReadonly,
    mode: context.form.id ? 'edition' : 'creation',
    platform: context.platform,
    idPreSelectedFormType: context.form.formTemplate.id,
    idFormType: data.formTemplateId,
    form: {
      ...data,
      ...jsonData,
    },
  };
}

export function formatFormTemplates(data) {
  return data.map((el) => {
    return {
      ...el,
      name: el.Description,
    };
  });
}

export function formatFormType(data) {
  try {
    const result = JSON.parse(data);
    const response = {};

    if (result.length > 0) {
      response.id = result[0].id;
      response.description = result[0].description;
    }
    return response;
  } catch (error) {
    return null;
  }
}

export function genericResponseCall(id, timeout, func) {
  return new Promise((resolve, reject) => {
    const eventFunc = (event) => {
      clearTimeout(timeout);
      window.removeEventListener(id, eventFunc);
      resolve(event.detail);
    };
    const timeoutFunc = () => {
      window.removeEventListener(id, eventFunc);
      reject({ error: `${id} timeout` });
    };

    window.addEventListener(id, eventFunc);
    timeout = timeout && setTimeout(timeoutFunc, 3000);
    func();
  });
}
